import { Component, Inject, OnInit } from '@angular/core';
import { ImageDTO } from '@app/core/services/user/models/imageDTO';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilService } from '@app/core/services/util/util.service';

export interface PhotosData {
  image: ImageDTO;
}

@Component({
    selector: 'ap-image-viewer-dialog',
    templateUrl: './image-viewer-dialog.component.html',
    styleUrls: ['./image-viewer-dialog.component.css'],
    standalone: false
})
export class ImageViewerDialogComponent implements OnInit {

  image: ImageDTO;
  src: any;

  constructor(private dialogRef: MatDialogRef<ImageViewerDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: PhotosData, private utilService: UtilService) {
  }

  ngOnInit(): void {
    if (this.data.image) {
      this.image = this.data.image;
      this.src = this.utilService.createUrlFromArrayBuffer(this.image);
    }
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
